/** @format */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageNumber: 1,
  pageSize: 10,
  jobIdCache: "",
  nameCache: "",
  phoneNumberCache: "",
  emailCache: "",
  applicationNoCache: "",
  gender: "",
  submittedOn: "",
  uuid: "",
  submittedOnStartDateCache: "",
  submittedOnEndDateCache: "",
  appointmentStartDateCache: "",
  appointmentEndDateCache: "",
  paymentStatusCache: "",
  clearFilterFlag: 0,
  departmentList: [],
  masterProcessList: [],
  processList: [],
};

const EidAppointDetailsFilterSlice = createSlice({
  name: "eidAppointmentFilter",
  initialState,
  reducers: {
    getPageNumber(state, action) {
      state.pageNumber = action.payload;
    },
    getPageSize(state, action) {
      state.pageSize = action.payload;
    },
    getJobId(state, action) {
      state.jobIdCache = action.payload
    },
    getName(state, action) {
      state.nameCache = action.payload;
    },
    getPhoneNumber(state, action) {
      state.phoneNumberCache = action.payload;
    },
    getEmail(state, action) {
      state.emailCache = action.payload;
    },
    getApplicationNo(state, action) {
      state.applicationNoCache = action.payload;
    },
    getGender(state, action) {
      state.gender = action.payload;
    },
    getSubmittedOn(state, action) {
      state.submittedOn = action.payload;
    },
    getUuid(state, action) {
      state.uuid = action.payload;
    },
    getSubmittedOnStartDate(state, action) {
      state.submittedOnStartDateCache = action.payload;
    },
    getSubmittedOnEndDate(state, action) {
      state.submittedOnEndDateCache = action.payload;
    },
    getAppointmentStartDate(state, action) {
      state.appointmentStartDateCache = action.payload;
    },
    getAppointmentEndDate(state, action) {
      state.appointmentEndDateCache = action.payload;
    },
    getPaymentStatus(state, action) {
      state.paymentStatusCache = action.payload;
    },
    getClearFilterFlag(state, action) {
      state.clearFilterFlag = action.payload;
    },
    getDepartmentList(state, action) {
      state.departmentList = action.payload;
    },
    getMasterProcessList(state, action) {
      state.masterProcessList = action.payload;
    },
    getProcessList(state, action) {
      state.processList = action.payload;
    },
    reset(state) {
      state.pageNumber = 1;
      state.pageSize = 10;
      state.nameCache = "";
      state.phoneNumberCache = "";
      state.emailCache = "";
      state.applicationNoCache = "";
      state.gender = "";
      state.submittedOn = "";
      state.uuid = "";
      state.jobIdCache = ""
      state.paymentStatusCache = "";
      state.departmentList = [];
      state.clearFilterFlag = 0;
      state.masterProcessList = [];
      state.processList = [];
      state.appointmentStartDateCache = "";
      state.appointmentEndDateCache = "";
      state.submittedOnStartDateCache = "";
      state.submittedOnEndDateCache = "";
    },
  },
});

export const {
  getPageNumber,
  getPageSize,
  getJobId,
  getName,
  getPhoneNumber,
  getEmail,
  getApplicationNo,
  getGender,
  getSubmittedOn,
  getUuid,
  getAppointmentStartDate,
  getAppointmentEndDate,
  getSubmittedOnStartDate,
  getSubmittedOnEndDate,
  getPaymentStatus,
  getDepartmentList,
  getMasterProcessList,
  getProcessList,
  getClearFilterFlag,
  reset,
} = EidAppointDetailsFilterSlice.actions;

export default EidAppointDetailsFilterSlice.reducer;
